module.exports = __webpack_public_path__ + "static/media/btn_quiz.03b7b0ae.png";